import {forwardRef} from 'react';
import Paper, {type PaperProps} from '@mui/material/Paper';

import {FLOATING_SHADOW} from '../../newVariablePicker/shared/floatingShadow';

// Round only the corners away from the field, including when Popper flips above it.
const SelectListPaper = forwardRef<HTMLDivElement, PaperProps>(({sx: _sx, ...props}, ref) => (
    <Paper
        ref={ref}
        variant={'outlined'}
        {...props}
        sx={{
            borderRadius: 2,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            boxShadow: FLOATING_SHADOW,
            '[data-popper-placement^="top"] &': {
                borderRadius: 2,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }}
    />
));

export default SelectListPaper;
